import { defineMessages } from 'react-intl';

export default defineMessages({

    AccountNumber: {
        id: 'agent.registration.edit.Account Number',
        defaultMessage: 'Account Number',
    },
    ConfirmAccountNumber: {
        id: 'agent.registration.edit.Confirm Account Number',
        defaultMessage: 'Confirm Account Number',
    },
    RoutingNumber: {
        id: 'agent.registration.edit.Routing Number',
        defaultMessage: 'Routing Number',
    },
    RoutingNumberPlaceholder: {
        id: 'agent.registration.edit.RoutingNumber.Placeholder',
        defaultMessage: '999999999',
    },
    AccountType: {
        id: 'agent.registration.edit.Account Type',
        defaultMessage: 'Account Type',
    },
    CheckImage: {
        id: 'agent.registration.edit.Check Image',
        defaultMessage: 'Check Image',
    },
    UploadInstructions: {
        id: 'agent.registration.edit.UploadInstructions',
        defaultMessage: 'Upload copy of a blank check with \"VOID\" written on the face of the check',
    },
    EditDirectDepositTextTFPA: {
        id: 'agent.registration.views.EditDirectDepositTextTFPA',
        defaultMessage: 'For the account indicated above, I hereby authorize Texas FAIR Plan Association Insurance to initiate credit entries (deposits) and adjustments for any credit entries in error. This authority remains in full force and effect until Texas FAIR Plan Association Insurance has received notification from me of its termination in such manner as to afford the Association and my bank a reasonable opportunity to act. It is my responsibility to verify that funds transferred to my account are available for disbursement. Texas FAIR Plan Association Insurance  is not responsible for bank fees incurred due to my failure to verify the availability of deposited funds.',
    },
    EditDirectDepositTextTWIA: {
        id: 'agent.registration.views.EditDirectDepositTextTWIA',
        defaultMessage: 'For the account indicated above, I hereby authorize Texas Windstorm Insurance Association to initiate credit entries (deposits) and adjustments for any credit entries in error. This authority remains in full force and effect until Texas Windstorm Insurance Association has received notification from me of its termination in such manner as to afford the Association and my bank a reasonable opportunity to act. It is my responsibility to verify that funds transferred to my account are available for disbursement. Texas Windstorm Insurance Association is not responsible for bank fees incurred due to my failure to verify the availability of deposited funds.',
    },
    documentUploadFailed: {
        id: 'agent.registration.views.Document upload failed1',
        defaultMessage: 'Document upload failed',
    },
    documentCannotUploaded: {
        id: 'agent.registration.views.Document service is not available1',
        defaultMessage: 'Document service is not available',
    },
    uploadDocumentTitle: {
        id: 'agent.registration.views. Upload Document',
        defaultMessage: 'Upload Document',
    },
    mustUploadDocumentMsg: {
        id: 'agent.registration.views. Must Upload Document',
        defaultMessage: 'Must Upload Document',
    },
    saveFailedTitle: {
        id: 'agent.registration.views. Unable to Save Payment Preferences',
        defaultMessage: 'Unable to Save Payment Preferences',
    },
    saveFailedMsg: {
        id: 'agent.registration.views. Unable to Save Payment Preferences, Please Contact Administrator',
        defaultMessage: 'Unable to Save Payment Preferences, Please Contact Administrator',
    },
    removeCheckTitle: {
        id: 'agent.registration.views. Remove Document',
        defaultMessage: 'Remove Document',
    },
    removeCheckMessage: {
        id: 'agent.registration.views. Are you sure you want to remove SampleCheck',
        defaultMessage: 'Are you sure you want to remove {documentname}',
    },

});
